<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title :class="['headline accent-3',getColor]" primary-title>
          {{ messageType }} Message
        </v-card-title>

        <v-card-text>
          {{ errorMessage }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :class="['accent-3 white--text',getColor]" flat @click="error = false">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: ["error", "errorMessage", "messageType"],
  data() {
    return {
    };
  },
  computed: {
   getColor: function(){
    // console.log(this.messageType);
    if(this.messageType=="success"){
      return "success";
    }else{
      return "red";
    }
   }
  },
  methods:{

  },
};
</script>